<template lang="html">
  <div class="">
    <vs-tabs>
      <vs-tab label="Reels Comments">
        <div class="con-tab-ejemplo">
          <ReelsComments/>
        </div>
      </vs-tab>
      <vs-tab label="Stories Comments">
        <div class="con-tab-ejemplo">
          <StoriesComments/>
        </div>
      </vs-tab>
      <vs-tab label="Posts Comments">
        <div class="con-tab-ejemplo">
          login
        </div>
      </vs-tab>

    </vs-tabs>
  </div>
</template>
<script>
import ReelsComments from './reelsComments.vue'
import StoriesComments from './StoriesComments.vue'
export default {
    components:{
        ReelsComments,StoriesComments
    }
}
</script>